import { withCurrentParams } from 'actions/utils';
import { getSceneLayerIds } from 'actions/Broadcast/utils';
import { OverlayStyles } from 'constants/LayerPositions';
import { OVERLAY_POSITION_TOGGLE } from 'store/eventConstants';
import { BROADCAST_UPDATE_OVERLAY_POSITION } from 'actions/Types';
import updateSceneLayers from '@shoflo/studio-redux/actions/sceneLayer/updateSceneLayers';

export default (overlayId, position) => {
  return withCurrentParams(
    (dispatch, { teamId, eventId, broadcastId }, getState, socket) => {
      const action = {
        type: BROADCAST_UPDATE_OVERLAY_POSITION,
        request: async apiClient => {
          const payload = {
            layer: {
              title: position,
              style: OverlayStyles[position]
            }
          };

          const broadcast = await apiClient.broadcast.updateOverlay(
            teamId,
            eventId,
            broadcastId,
            overlayId,
            payload
          );

          const {
            meeting: { attendeeResponse }
          } = getState();
          const { overlays } = broadcast;
          const updatedOverlay = overlays.find(
            overlay => overlay._id === overlayId
          );
          const { hidden } = updatedOverlay.source;

          if (!hidden) {
            const sceneLayerIds = getSceneLayerIds(broadcast);
            dispatch(updateSceneLayers(sceneLayerIds));
          }
          // notify other directors
          socket.emit(OVERLAY_POSITION_TOGGLE, {
            overlayId,
            broadcastId,
            notifyingDirector:
              attendeeResponse && attendeeResponse.Attendee.AttendeeId
          });
          return updatedOverlay;
        }
      };
      dispatch(action);
    }
  );
};
